import {Component} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ServiceAccountService} from "./service-account.service";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {UserModel, userModelFactory} from "../types/user.model";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {handleErrors} from "../misc/handle-errors.decorator";

@Component({
  selector: "edit-service-account",
  templateUrl: "./edit-service-account.template.pug",
  providers: [ServiceAccountService],
})

export class EditServiceAccountComponent extends RouteHelper {
  saId: string;
  user: UserModel = userModelFactory();
  error: Error;
  rolesSelected: any[] = [];
  roles: any[] = [];

  paramsMap: RouteMapping[] = [
    {fieldName: "saId", paramName: "id"} as RouteMapping,
  ];

  navigate(queryParams: Params): Promise<boolean> {
    return this.router.navigate(["edit-service-account"], {queryParams});
  }

  @handleErrors()
  async loadData(): Promise<void> {
    this.error = undefined;

    const {user, userRoles, roles} = await this.serviceAccountService.getServiceAccountById(this.saId);

    if (!user) throw new Error("Service Account not found");

    this.roles = roles;
    this.rolesSelected = userRoles;
    this.user = user;
  }

  constructor(
    private serviceAccountService: ServiceAccountService,
    public route: ActivatedRoute,
    public router: Router,
    public appSettingsService: AppSettingsService,
  ) {
    super();
  }

  @handleErrors()
  async save() {
    this.error = undefined;

    const response = await this.serviceAccountService.saveUserWithRoles(this.user, this.rolesSelected);
    if (response.error) throw new Error(response.error);

    this.router.navigate(["service-accounts"]);
  }

  cancel(): void {
    this.router.navigate(["service-accounts"]);
  }
}
